module.exports = __webpack_public_path__ + "img/Sales_service_pic01.15c1693b.jpg";